<div class="flex flex-col gap-medpace *:grid *:grid-cols-3 *:gap-medpace *:break-words">
    <div>
        <div>
            <h5>From Location</h5>
            <span>{{ expense().mileageStartLocation ?? 'Unspecified' }} </span>
        </div>
        <div>
            <h5>To Location</h5>
            <span>{{ expense().mileageEndLocation ?? 'Unspecified' }} </span>
        </div>
        <div>
            <h5>Country</h5>
            <span>{{ (country$ | async)?.name ?? 'Unspecified' }} </span>
        </div>
        <div>
            <h5>Total Distance</h5>
            @if (expense().mileageTotalDistance && distanceUnit()) {
                <span>{{ expense().mileageTotalDistance }} {{ distanceUnit() }} </span>
            } @else {
                <span>Unspecified</span>
            }
        </div>
    </div>

    <div>
        <!-- col-span-3 makes it full-width -->
        <div class="col-span-3">
            <h5>Additional Details</h5>
            <span>{{ expense().mileageComments ?? 'Unspecified' }} </span>
        </div>
    </div>
    <div>
        <div>
            <h5>Receipt Date</h5>
            <span>{{ (expense().timestamp | dateFormat: undefined : 'local' | uppercase) ?? 'Unspecified' }} </span>
        </div>
    </div>
    <div>
        <div>
            <h5>Requested ({{ expense().currency }})</h5>
            <span>{{ (expense().amount | number: '1.2-2' : 'en-US') ?? 'Unspecified' }}</span>
        </div>
        @let elevatedAccess = elevatedAccess$ | async;
        @let isInProcessOrHigher = isInProcessOrHigher$ | async;
        @if (isInProcessOrHigher === true) {
            <!-- Authorized in local currency can be viewed by CRC -->
            <div>
                <h5>Authorized ({{ expense().currency }})</h5>
                <span>{{ (expense().authorizedAmount | number: '1.2-2' : 'en-US') ?? 'Unspecified' }}</span>
            </div>
        }
    </div>
</div>

@if (isInProcessOrHigher === true && elevatedAccess === true) {
    <div class="flex flex-row gap-medpace pt-medpace">
        @if (authorizedAmountPatientsCurrencyChip()) {
            <mds-chip
                [chips]="authorizedAmountPatientsCurrencyChip()"
                [chipListType]="'basic'"
                [multiple]="true"
            ></mds-chip>
        }
        @if (authorizedAmountUSDChip()) {
            <mds-chip [chips]="authorizedAmountUSDChip()" [chipListType]="'basic'" [multiple]="true"></mds-chip>
        }
    </div>
}
